import styled from "styled-components";
import { theme } from "../theme/theme";
import { Link } from "./Link";

export const LinkButton = styled(Link)`
  background-color: ${theme.primary};
  width: fit-content;
  border-radius: 80px;
  color: #fff;
  padding: 16px 32px;
  text-align: center;
  font-family: "Source sans 3";
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  gap: 16px;
  :hover {
    opacity: 0.92;
  }
  &,
  svg {
    transition: all 0.3s ease;
  }
  :hover {
    svg {
      transform: translateX(5px);
    }
  }
`;
